import React from 'react';
import { Link } from 'react-router-dom';

import * as routes from '../routes.json';

const NotFound = () => (
  <div>
    <h1>404</h1>
    <p>This page cannot be found.</p>
    <Link to={routes.home}>Return to Home</Link>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.jsx